import { dataFaccaoReducer } from './dataFaccaoReducer';
import { dataPedidoReducer } from './dataPedidoReducer';
import { dataPvReducer } from './dataPvReducer';
import { pedidoReducer } from './pedidoReducer';
import { loadingReducer } from './loadingReducer';
import { toasterReducer } from './toasterReducer';
import { capacidadeReducer } from './capacidadeReducer';
import { indiceQualidadeReducer } from './indiceQualidadeReducer';
import { somatorioReducer } from './somatorioReducer';
import { loadReducer } from './loadReducer';
import { factionFiltersReducer } from './factionFiltersReducer';

import { combineReducers } from 'redux';

export const Reducers = combineReducers({
    dataPvState: dataPvReducer,
    pedidoState: pedidoReducer,
    dataPedido: dataPedidoReducer,
    dataFaccao: dataFaccaoReducer,
    toasterState: toasterReducer,
    loadingState: loadingReducer,
    capacidadeState: capacidadeReducer,
    indiceQualidadeState: indiceQualidadeReducer,
    somatorioState: somatorioReducer,
    loadState: loadReducer,
    factionFilters: factionFiltersReducer,
});
